import React from "react";
import { Redirect, Switch } from "react-router-dom";

import AdminNavbar from "common/components/Navbars/LoggedNavbar.js";
import Footer from "common/components/Footer/Footer.js";
import Sidebar from "common/components/Sidebar/Sidebar.js";

import routes from "admin-routes.js";
import RouterPaths from "../common/constants/RouterPaths";
import ProtectedAdminRoute from "../common/hoc/ProtectedAdminRoute";

class AdminLayout extends React.Component {
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }

  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      return (
        <ProtectedAdminRoute
          path={prop.path}
          component={prop.component}
          exact
          key={key}
        />
      );
    });
  };

  render() {
    return (
      <div>
        <Sidebar {...this.props} />
        <div className="main-panel">
          <AdminNavbar {...this.props} handleMiniClick={this.handleMiniClick} />
          <Switch>
            {this.getRoutes(routes)}
            <Redirect to={RouterPaths.ADMIN_USERS} />
          </Switch>
          {// we don't want the Footer to be rendered on full screen maps page
          this.props.location.pathname.indexOf("full-screen-map") !==
          -1 ? null : (
            <Footer fluid />
          )}
        </div>
      </div>
    );
  }
}

export default AdminLayout;
